import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async create(data) {
    return await axiosIns.post(obtenerUrlAPIPagos('inscripcion-programa-universidad'), data);
  },
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('inscripcion-programa-universidad'), { params: opciones.params });
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIPagos(`inscripcion-programa-universidad/${id}`));
  },
  async update(id, data) {
    return await axiosIns.patch(obtenerUrlAPIPagos(`inscripcion-programa-universidad/${id}`), data);
  },
  async remove(id, data) {
    return await axiosIns.delete(obtenerUrlAPIPagos(`inscripcion-programa-universidad/${id}`), { data });
  },
};
